import { Stack, Typography } from '@mui/material'

interface AppPriceProps {
  price: number
}

export const AppPrice = (props: AppPriceProps) => {
  const { price } = props

  return (
    <Stack spacing={1} direction="row" alignItems="center" justifyContent="space-between">
      <Typography variant="body2" color="text.secondary">
        Total Price
      </Typography>
      <Stack direction="row" alignItems="center" spacing={1}>
        <Typography variant="h5" component="span">
          {price.toLocaleString('en-AU', {
            style: 'currency',
            currency: 'AUD',
            maximumFractionDigits: 2,
          })}
        </Typography>
        <Typography variant="caption" color="text.secondary">
          (Ex GST)
        </Typography>
      </Stack>
    </Stack>
  )
}
